<template>
  <div>
    <van-field
      v-model="val"
      :label="label"
      :placeholder="placeholder || label"
      :required="required"
      :rules="[{ required: required, message: '请输入' + label }]"
      readonly
      is-link
      @click="show = true"
    />
    <van-action-sheet v-model="show" :actions="actions"
                      :title="'选择 ' + label" @select="select"
    />
  </div>
</template>
<script>
export default {
  model: {
    prop: 'value',
    event: 'change'
  },
  props: {
    label: {
      type: String,
      default: ''
    },
    placeholder: {
      type: String,
      default: ''
    },
    options: {
      type: Array,
      default: function() {
        return []
      }
    },
    value: {
      type: Number,
      default: 0
    },
    labelAttr: {
      type: String,
      default: 'name'
    },
    valueAttr: {
      type: String,
      default: 'id'
    },
    required: {
      type: Boolean,
      default: false
    }
  },
  data() {
    return {
      show: false,
      val: this.value ? this.options.find(action => action.id === this.value).name : '',
      actions: this.options
    }
  },
  watch: {
    value: function(value) {
      this.val = value ? this.options.find(action => action.id === value).name : ''
    },
    options: function(options) {
      this.actions = options
    }
  },
  methods: {
    select(action) {
      this.val = action[this.labelAttr]
      this.$emit('change', this.actions.find(ac => ac.name === this.val).id, this.actions)
      this.show = false
    }
  }
}
</script>



// WEBPACK FOOTER //
// src/components/base/BaseSelect.vue